import API from '../../../../hooks/api';
import { userLoginData } from './ScreenHelper';

export const checkDataAPI = async (
        data: userLoginData,
        callBack: (success: boolean, errorMsg: string | null) => void = () => {}
    ) => {
    await API.get("/connect/merchant/password/reset/check", {params: data})
    .then((res) => {
        console.log(res)
        callBack(true, null);
    }).catch((err) => {
        callBack(false, err);
    });
}
